import type { Parceiro } from "./tipos"

// Sólides (solides.com.br), plataforma de gestão de pessoas que leva o consignado aos clientes dela.
// Cores e fonte tiradas do site deles: o roxo da marca nas superfícies, e o mesmo roxo como neutro
// dos gráficos — ele fica longe do vermelho de "barrado", ao contrário do magenta de destaque.
//
// Sem arquivo oficial do logo ainda: o nome vai escrito na fonte e na cor da marca.
export const SOLIDES: Parceiro = {
    slug: "solides",
    nome: "Sólides",
    doParceiro: "da Sólides",
    comArtigo: "a Sólides",
    tituloDaAba: "Sólides · Portal do Empregador",
    marca: { tipo: "texto", texto: "sólides" },
    dominios: [],
    operadoPelaFazCred: true,
    tema: {
        claro: {
            brand: "#80297d",
            "brand-ink": "#ffffff",
            "brand-strong": "#66205f",
            "brand-wash": "#f7e3fa",
            data: "#80297d",
            page: "#faf9fa",
            card: "#ffffff",
            sunk: "#f0eaf1",
            ink: "#33373d",
            soft: "#3f434a",
            faint: "#6b6f77",
            line: "#e6e0e8",
            "line-strong": "#cfc5d2",
        },
        escuro: {
            brand: "#d68fd3",
            "brand-ink": "#1c151f",
            "brand-strong": "#e3aade",
            "brand-wash": "#3d1246",
            data: "#c26bbf",
            page: "#120d15",
            card: "#1c151f",
            sunk: "#2a1f2e",
            ink: "#f4eef6",
            soft: "#e0d8e3",
            faint: "#b6aeba",
            line: "#312635",
            "line-strong": "#4a3c4f",
        },
    },
    fontes: {
        titulo: "Poppins, ui-sans-serif, system-ui, sans-serif",
        texto: "Poppins, ui-sans-serif, system-ui, sans-serif",
        numeros: "Poppins, ui-sans-serif, system-ui, sans-serif",
        // Poppins não tem versão variável: um arquivo por peso, só os que o painel usa.
        carregar: () =>
            Promise.all([
                import("@fontsource/poppins/400.css"),
                import("@fontsource/poppins/500.css"),
                import("@fontsource/poppins/600.css"),
                import("@fontsource/poppins/700.css"),
                import("@fontsource/poppins/800.css"),
            ]),
    },
}
